const TermsAndConditions = () => {
  return (
    <div
      style={{
        backgroundColor: "#0d1320",
        minHeight: "100vh",
        color: "#e5e7eb",
      }}
    >
      <header className="bg-[#0d1320] shadow w-full z-10">
        <div className="max-w-5xl mx-auto py-4 px-6 flex justify-center">
          <h1 className="text-2xl font-semibold text-white underline text-center">
            Terms and Conditions
          </h1>
        </div>
      </header>

      <main className="px-6 max-w-5xl mx-auto pb-16">
        <p className="text-sm text-gray-600 mb-4">Last Updated: May 20, 2025</p>

        <p className="mb-4">
          Welcome to Onelyk (“we,” “our,” or “us”). These Terms and Conditions
          (“Terms”) govern your access to and use of our guest engagement and
          review management software platform (“Service”) provided to hotel
          owners and operators (“you,” “your,” “Customer”).
        </p>

        <p className="mb-4">
          By accessing or using the Service, you agree to be bound by these
          Terms. If you do not agree, you may not use the Service.
        </p>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">1. Service Overview</h2>
          <p className="mb-2">
            Onelyk provides a software-as-a-service (SaaS) platform that enables
            hotel owners to:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Engage directly with guests through SMS, email, QR code, or
              in-room interactions.
            </li>
            <li>
              Automate guest messaging before, during, and after the stay.
            </li>
            <li>
              Collect, manage, and respond to reviews from platforms such as
              Google, TripAdvisor, Expedia, and Booking.com.
            </li>
            <li>
              Monitor guest feedback, team performance, and reputation KPIs
              through a centralized dashboard.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            2. Data Privacy & PII Compliance
          </h2>
          <p className="mb-2">
            We understand the critical importance of guest data privacy,
            especially Personally Identifiable Information (PII). We take all
            reasonable steps to ensure that your guests’ data is handled in
            accordance with applicable laws, including but not limited to GDPR,
            CCPA, and other data protection regulations.
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <strong>Data Collection:</strong> We collect guest data only as
              necessary to deliver the Service.
            </li>
            <li>
              <strong>Data Usage:</strong> Guest data will only be used for the
              purposes of guest engagement and review collection, as defined by
              the Customer.
            </li>
            <li>
              <strong>Third-Party Sharing:</strong> We do not sell or share
              guest PII with third parties, except with integrated OTAs (e.g.,
              Expedia) or review platforms as authorized by you.
            </li>
            <li>
              <strong>Data Storage:</strong> All data is stored securely using
              encrypted infrastructure, hosted on trusted cloud providers (e.g.,
              AWS).
            </li>
            <li>
              <strong>Breach Notification:</strong> In the event of a data
              breach affecting PII, we will notify you within 72 hours.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            3. Customer Responsibilities
          </h2>
          <p className="mb-2">As a Customer, you agree to:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>Provide accurate information when creating your account.</li>
            <li>
              Obtain consent from your guests before sending them marketing or
              review-related communication, as required by law.
            </li>
            <li>
              Use the Service only for lawful hotel or hospitality-related
              purposes.
            </li>
            <li>Maintain the confidentiality of your account credentials.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            4. Third-Party Integrations
          </h2>
          <p className="mb-2">
            The Service may integrate with third-party services such as OTAs
            (Expedia, Booking.com), review platforms (Google, Yelp), and
            communication tools (SMS/email providers).
          </p>
          <p className="mb-2">
            We are not responsible for the functionality, data policies, or
            terms of use of these third-party platforms. You are responsible for
            complying with the terms of those platforms when using our
            integrations.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            5. Intellectual Property
          </h2>
          <p>
            All content and software provided by Onelyk is owned by us or our
            licensors. Reverse engineering or copying is prohibited.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">6. Fees and Billing</h2>
          <p>
            Charges may apply and are outlined in agreements. Failure to pay may
            result in service suspension.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">7. Termination</h2>
          <p>
            We reserve the right to terminate your account for violations or
            misuse. Data access may be restricted after termination.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            8. Limitation of Liability
          </h2>
          <p>
            We are not liable for indirect or consequential damages, including
            lost data or revenue.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">9. Indemnification</h2>
          <p>
            You agree to hold Onelyk harmless against claims resulting from
            misuse of our Service or violation of these Terms.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">10. Changes to Terms</h2>
          <p>
            We may update these Terms. Continued use of the Service means you
            accept any changes.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            11. Contact Information
          </h2>
          <p>
            Onelyk Inc.
            <br />
            Email:{" "}
            <a
              href="mailto:support@onelyk.com"
              className="text-blue-600 hover:underline"
            >
              support@onelyk.com
            </a>
            <br />
          </p>
        </section>
      </main>
    </div>
  );
};

export default TermsAndConditions;
